import { useContext, useCallback } from 'react';
import _ from 'lodash';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { CustomFormatterUtil, CustomIconUtil } from 'gw-portals-util-js';
import metadata from './RecurringPaymentInfoModal.metadata.json5';
import styles from './RecurringPaymentInfoModal.module.scss';
import { EnrollmentSummaryContext } from 'gw-capability-enrollment-react';

function RecurringPaymentInfoModal(props) {
    const prefSummary = useContext(EnrollmentSummaryContext);
    const { recurringInfoPaymentDetails } = props;
  
    const getNamedInsured = useCallback(() => {
        if (prefSummary) {
            const prefSummaryProfile = prefSummary.data.profile;
            const nullCheckPNI = (prefSummaryProfile.enrollments[0].primaryNamedInsured !== null);
            const primaryNamedInsured = nullCheckPNI ? prefSummaryProfile.enrollments[0].primaryNamedInsured
                : (`${prefSummaryProfile.contact.firstName} ${prefSummaryProfile.contact.lastName}`);
            return primaryNamedInsured;
        }
        return null;
    }, [prefSummary]);

    const overrideProps = {
        paymentMethodData: {
            content: recurringInfoPaymentDetails.paymentMethod
        },
        paymentDateData: {
            content: recurringInfoPaymentDetails.paymentDate
        },
        namedInsuredData: {
            content: getNamedInsured()
        },
        modalCreditCardExpDate: {
            className: recurringInfoPaymentDetails.creditCardExpDate ? "paymentModalRow creditCardDate" : "noDisplay"
        },
        modalRoutingNumber: {
            className: recurringInfoPaymentDetails.routingNumber ? "paymentModalRow" : "noDisplay"
        },
        nameCard: {
            className: recurringInfoPaymentDetails.cardName ? "paymentModalRow" : "noDisplay"
        },
        creditCardExpDate: {
            content: recurringInfoPaymentDetails.creditCardExpDate,
            className: recurringInfoPaymentDetails.creditCardExpDate ? "paymentModalData" : "noDisplay"
        },
        lastModifiedDate: {
            content:CustomFormatterUtil.formatDateLong(recurringInfoPaymentDetails.lastModDate)
        },
        nameOnCardData: {
            content: recurringInfoPaymentDetails.cardName,
            visible: recurringInfoPaymentDetails.cardName ? "paymentModalData" : "noDisplay"
        },
        routingNumberData : {
            content: recurringInfoPaymentDetails.routingNumber,
            visible: recurringInfoPaymentDetails.routingNumber ? "paymentModalData" : "noDisplay"
        },
        dismissPaymentModal: {
            src: CustomIconUtil.getLogoSrc('dismiss-icon.png'),
            onClick: props.dismissModal
        },
       
    };

    const resolvers = {
        resolveClassNameMap: styles,
    };

    return renderContentFromMetadata(
        metadata.componentContent,
        overrideProps,
        resolvers
    );
}

RecurringPaymentInfoModal.propTypes = {};

export default RecurringPaymentInfoModal;